import React, { useEffect, useState } from 'react';
import { Menu, X, Send } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: '首页 (Home)',
    href: '#hero'
  }, {
    name: '服务 (Services)',
    href: '#services'
  }, {
    name: '关于 (About)',
    href: '#why-us'
  }, {
    name: '技师 (Therapists)',
    href: '#therapists'
  }, {
    name: '评价 (Reviews)',
    href: '#testimonials'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#1a1a2e]/95 backdrop-blur-md py-4 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-85">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86">
        <div className="flex justify-between items-center" data-id="element-87">
          {/* Logo */}
          <a href="#" className="flex flex-col" data-id="element-88">
            <span className={`text-2xl font-bold font-serif tracking-wider ${isScrolled ? 'text-[#c9a96e]' : 'text-white'}`} data-id="element-89">
              新加坡幸福缘
            </span>
            <span className={`text-xs tracking-[0.2em] uppercase ${isScrolled ? 'text-gray-300' : 'text-gray-200'}`} data-id="element-90">
              Happiness Connection
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-91">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium transition-colors hover:text-[#c9a96e] ${isScrolled ? 'text-gray-300' : 'text-white'}`} data-id="element-92">
                {link.name}
              </a>)}
            <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="px-6 py-2 bg-[#c9a96e] text-[#1a1a2e] text-sm font-semibold rounded-sm hover:bg-[#d4af37] transition-colors duration-300 flex items-center gap-2" data-id="element-93">
              <Send size={16} data-id="element-94" />
              <span data-id="element-95">预约 (Book)</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-96">
            {isMobileMenuOpen ? <X size={24} data-id="element-97" /> : <Menu size={24} className={isScrolled ? 'text-[#1a1a2e]' : 'text-white'} data-id="element-98" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-99">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-[#1a1a2e] border-t border-gray-800" data-id="element-100">
            <div className="px-4 pt-2 pb-8 space-y-4 flex flex-col items-center" data-id="element-101">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-gray-300 hover:text-[#c9a96e] py-2 text-lg font-medium" data-id="element-102">
                  {link.name}
                </a>)}
              <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)} className="mt-4 px-8 py-3 bg-[#c9a96e] text-[#1a1a2e] font-semibold rounded-sm w-full text-center" data-id="element-103">
                立即预约 (Book Now)
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}